import { defineMessages } from 'react-intl'

export default defineMessages({
  witnessNoWitness: {
    id: 'app.claims.witness.nowitness',
    defaultMessage: 'No Witness',
  },
  witnessThereWasWitness: {
    id: 'app.claims.witness.thereWasWitness',
    defaultMessage: 'There Was a Witness',
  },
  witnessHeadline: {
    id: 'app.witness.headline',
    defaultMessage: 'Witness info',
  },

  // Validation messages
  validationAddressRequired: {
    id: 'app.witness.validation.addressRequired',
    defaultMessage: 'Address is required!',
  },
  validationPhoneRequired: {
    id: 'app.witness.validation.phoneRequired',
    defaultMessage: 'Phone number is required!',
  },
  validationFirstNameRequired: {
    id: 'app.witness.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.witness.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },

  // Placeholder messages
  placeholderFirstName: {
    id: 'app.witness.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.witness.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderPhoneNumber: {
    id: 'app.witness.placeholder.phoneNumber',
    defaultMessage: 'Phone #',
  },
  placeholderAdress: {
    id: 'app.witness.placeholder.address',
    defaultMessage: 'Address',
  },
})
